import { Component, Fragment } from "react";
import styles from "../../../assets/module/modal/modal.module.css";
import commstyles from "../../../assets/module/common/common.module.css";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Draggable from "react-draggable";
import { setValue } from '../../../controllers/commons/setValue';
import { checkUpdateResult2, checkValue, notifBeforeAct } from '../../../controllers/commons/helper';
import { enqueueSnackbar } from "notistack";
import { withRouter } from 'react-router-dom';

const UserController = require('../../../controllers/admins/users');
const LoginController = require('../../../controllers/authentications/login')

class ModalChangePassword extends Component {
  constructor(props) {
    super(props)
    this.state = this.getInitialState();
    this.reset = this.reset.bind(this);
  }

  getInitialState() {
    return {
      backdrop: 'static',
      error_message: '',
      v_confirm_pwd: "",
      v_new_pwd: "",
      s_i_confirm_pwd: "form-control",
      s_i_new_pwd: "form-control",

      showPass: false,
      showPass2: false,
    }
  }

  setConfirmPassword = async (e) => {
    await setValue(this, e.target.value, 'form-control', "form-control-err", /^.{1,16}$/, null, 'v_confirm_pwd', 's_i_confirm_pwd', null, false, null)
    if (e.target.value !== this.state.v_new_pwd && e.target.value.length > 0 && this.state.v_new_pwd !== "") {
      this.setState({ s_i_confirm_pwd: 'form-control-err', error_message: `Confirm passwords didn't match` });
    } else {
      this.setState({ s_i_confirm_pwd: 'form-control', error_message: '' });
    }
  }

  setNewPwd = (e) => {
    setValue(this, e.target.value, 'form-control', "form-control-err", /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!"#$%&'()*+,\-.:;<=>?@[\]^_`{|}).]).{8,16}$/,
      'Password must be 8-16 characters and include letters, numbers and special characters', 'v_new_pwd', 's_i_new_pwd', 'error_message', true, null)
    if (e.target.value !== this.state.v_confirm_pwd && e.target.value.length > 0 && this.state.v_confirm_pwd !== "") {
      this.setState({ s_i_new_pwd: 'form-control-err' });
    }
  }

  reset = () => {
    this.setState(this.getInitialState());
  }

  closeAlertSuccess = async () => {
    this.props.history.push('/logout');
  }

  save = async () => {
    try {
      if (this.check()) {
        let b = {
          p1: null,
          p2: this.state.v_new_pwd
        }
        await notifBeforeAct({ title: 'Are you sure to reset password?' })
          .then(async rc => {
            if (rc) {
              await UserController.resetPwd(b).then(x => {
                checkUpdateResult2({ x: x, funcSuccess: this.closeAlertSuccess })
              })
            }
          })
      }
    } catch (error) {
      enqueueSnackbar('Reset Failed', { variant: "error", autoHideDuration: 1200 })
    }

  }

  closeAlert = () => {
    this.props.toggleHandler();
  }

  check() {
    let rs = true;
    rs = checkValue(this, rs, this.state.v_confirm_pwd, 's_i_confirm_pwd', null, 'v')
    rs = checkValue(this, rs, this.state.v_new_pwd, 's_i_new_pwd', null, 'v')
    if (this.state.s_i_new_pwd === 'form-control-err' || this.state.s_i_confirm_pwd === 'form-control-err') {
      rs = false
      this.setState({
        s_i_new_pwd:'form-control-err'
      })
      enqueueSnackbar('Password must be 8-16 characters and include letters, numbers and special characters', { variant: "error", autoHideDuration: 3200 })
    }
    if(this.state.v_new_pwd !== this.state.v_confirm_pwd){
      rs = false
      this.setState({
        s_i_new_pwd:'form-control-err',
        s_i_confirm_pwd:'form-control-err'
      })
      enqueueSnackbar('Confirm Password Not Match', { variant: "error", autoHideDuration: 3200 })
    }
    return rs;
  }

  setShowPass = (e) => {
    this.setState({ showPass: !this.state.showPass });
  }
  setShowPass2 = (e) => {
    this.setState({ showPass2: !this.state.showPass2 });
  }

  enterHandle = (e) => {
    if (e.key === 'Enter') {
      this.save()
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  render() {
    return (
      <Fragment>
        <Draggable handle=".drag">
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.toggleHandler}
            className={`${styles["modal-w-30"]}`}
            onClosed={this.reset}
            backdrop={this.state.backdrop}>
            <ModalHeader toggle={this.props.toggleHandler} className={`${styles["lbl_modal"]} drag`}>Change Password</ModalHeader>
            <ModalBody>
              <div>
                <div className={`${styles["dv-pass"]} ${styles["flex"]} `}>
                  <label className={styles["lbl_modal"]} >New Password</label>
                  <div className={`${commstyles['col-1']}`}>
                    <div className={`${commstyles['password']} ${commstyles['col-1']}`}>
                      {
                        this.state.showPass ? <i className={`fa fa-eye-slash ${commstyles['icon-eye']}`} onClick={e => this.setShowPass(e)}></i> :
                          <i className={`fa fa-eye ${commstyles['icon-eye']}`} onClick={e => this.setShowPass(e)}></i>
                      }

                      <input
                        className={`${styles[this.state.s_i_new_pwd]}`}
                        id="new-pwd"
                        placeholder="Enter Password"
                        type={this.state.showPass ? "text" : "password"}
                        onChange={this.setNewPwd}
                        maxLength={16}
                        onKeyUp={e => this.enterHandle(e)}
                      />
                    </div>
                  </div>

                </div>

                <div className={styles["dv-pass"]}>
                  <label className={styles["lbl_modal"]} >Confirm Password</label>
                  <div className={`${commstyles['password']} ${commstyles['col-1']}`}>
                    {
                      this.state.showPass2 ? <i className={`fa fa-eye-slash ${commstyles['icon-eye']}`} onClick={e => this.setShowPass2(e)}></i> :
                        <i className={`fa fa-eye ${commstyles['icon-eye']}`} onClick={e => this.setShowPass2(e)}></i>
                    }

                    <input
                      className={`${styles[this.state.s_i_confirm_pwd]}`}
                      id="confirm-pwd"
                      placeholder="Enter Password"
                      type={this.state.showPass2 ? "text" : "password"}
                      onChange={this.setConfirmPassword}
                      maxLength={16}
                      onKeyUp={e => this.enterHandle(e)}
                    />
                  </div>
                </div>
                <label className={commstyles["error_msg_comm"]} >{this.state.error_message}</label>
              </div>
            </ModalBody>
            <ModalFooter className="drag">
              <button className={`${styles["btn-primary"]} ${styles["btn"]}`} onClick={this.save}>Save</button>
              <button className={`${styles["btn-secondary"]} ${styles["btn"]}`} onClick={this.props.toggleHandler}>Cancel</button>
            </ModalFooter>

          </Modal>

        </Draggable>

      </Fragment>
    )
  }
}

// export default ModalChangePassword;
export default withRouter(ModalChangePassword);